export function reactSelectStyles(tombac) {
  return {
    control: (provided, // @ts-expect-error -- We use custom props in `selectProps`, which are not part of the react-select types
    _ref) => {
      let {
        isDisabled,
        isFocused,
        selectProps: {
          invalid,
          variant,
          size
        }
      } = _ref;
      return {
        all: "initial",
        ...provided,
        height: "100%",
        borderRadius: tombac.unit(7),
        boxShadow: undefined,
        transition: "0.1s ease-out",
        transitionProperty: "background-color, border-color",
        "&:hover": {
          backgroundColor: tombac.color("neutral", 200),
          borderColor: undefined
        },
        // Variant styles
        ...((variant === "danger" || invalid) && {
          borderColor: tombac.color("danger", 500)
        }),
        ...(variant === "alert" && {
          borderColor: tombac.color("alert", 500)
        }),
        // Size styles
        minHeight: tombac.space(5),
        ...(size === "s" && {
          minHeight: tombac.space(4)
        }),
        // State styles
        ...(isFocused && {
          borderColor: provided.borderColor
        }),
        ...(isDisabled && {
          backgroundColor: tombac.color("neutral", 300),
          borderColor: tombac.color("neutral", 400),
          "&:hover": {}
        })
      };
    },
    // @ts-expect-error -- See above
    dropdownIndicator: (provided, _ref2) => {
      let {
        selectProps: {
          isDisabled,
          size
        }
      } = _ref2;
      return {
        all: "initial",
        ...provided,
        color: tombac.color("neutral", 900),
        "&:hover": {
          color: tombac.color("neutral", 900)
        },
        // Size styles
        padding: tombac.space(1),
        ...(size === "s" && {
          padding: tombac.space(0.5)
        }),
        // State styles
        ...(isDisabled && {
          color: tombac.alpha("neutral", 24),
          "&:hover": {}
        })
      };
    },
    indicatorSeparator: () => ({}),
    input: provided => ({
      all: "initial",
      ...provided,
      ...tombac.text(),
      marginLeft: tombac.space(1),
      marginRight: tombac.space(1),
      input: {
        fontSize: 14,
        fontFamily: "inherit",
        paddingTop: "6px !important" // Fixes font alignment
      }
    }),
    menu: provided => ({
      all: "initial",
      ...provided,
      ...tombac.text({
        color: tombac.color("neutral", 600)
      }),
      border: `${tombac.unit(1)} solid ${tombac.color("neutral", 400)}`,
      borderRadius: tombac.unit(7),
      boxShadow: undefined,
      marginTop: tombac.space(0.5)
    }),
    option: (provided, _ref3) => {
      let {
        isFocused,
        isSelected,
        isDisabled
      } = _ref3;
      return {
        all: "initial",
        ...provided,
        ...tombac.text({
          color: tombac.color("neutral", 900),
          fontSize: 14
        }),
        backgroundColor: tombac.color("neutral", 100),
        cursor: "pointer",
        padding: tombac.space(1, 2),
        paddingTop: `calc(${tombac.space(1)} + 2px)`,
        // Fixes font alignment
        transition: "0.1s ease-out",
        transitionProperty: "background-color, color",
        "&:active": {
          backgroundColor: tombac.color("neutral", 400)
        },
        // State styles
        ...(isSelected && {
          color: tombac.color("accent", 600)
        }),
        ...(isFocused && {
          backgroundColor: tombac.color("neutral", 300)
        }),
        ...(isDisabled && {
          color: tombac.color("neutral", 600),
          cursor: "no-drop",
          "&:active": {}
        })
      };
    },
    placeholder: provided => ({
      all: "initial",
      ...provided,
      ...tombac.text({
        color: tombac.color("neutral", 600)
      }),
      marginLeft: tombac.space(1),
      marginRight: tombac.space(1),
      paddingTop: "3px !important",
      // Fixes font alignment
      whiteSpace: "nowrap"
    }),
    singleValue: (provided, _ref4) => {
      let {
        isDisabled
      } = _ref4;
      return {
        all: "initial",
        ...provided,
        ...tombac.text(),
        marginLeft: tombac.space(1),
        marginRight: tombac.space(1),
        paddingTop: "2px",
        // Fixes font alignment
        // State styles
        ...(isDisabled && {
          color: tombac.alpha("neutral", 24),
          cursor: "default"
        })
      };
    }
  };
}
//# sourceMappingURL=reactSelectStyles.js.map